export default __webpack_public_path__ + "static/media/02_DAIF_Services_05_end.5b1fb498.jpg";